import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * Route-level RBAC guard. SuperAdmin (wildcard '*') always passes.
 * Renders a graceful access-restricted card instead of mounting the page
 * when the user lacks the required permission (prevents direct-URL data leaks).
 */
export function RequirePermission({ code, children }) {
  const { hasPermission, isSuperAdmin } = useAuth();
  if (isSuperAdmin || hasPermission(code)) return children;
  return (
    <div className="bg-card border border-border rounded-xl p-12 text-center max-w-xl mx-auto mt-10" data-testid="access-restricted">
      <Lock className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
      <h3 className="text-base font-semibold text-foreground">Access restricted</h3>
      <p className="text-sm text-muted-foreground mt-1">
        You don't have permission to view this page. It requires the
        <span className="font-mono text-xs mx-1 px-1.5 py-0.5 rounded bg-muted">{code}</span>
        permission. Contact your administrator if you need access.
      </p>
    </div>
  );
}
